import { useSelector } from "react-redux";
import { Tabs } from "@mantine/core";
import DataWrapper from "../../../../../common/components/DataWrapper/DataWrapper";

const PolicyIssuedByUser = () => {
  const userProfile = useSelector((state) => state.userProfile);
  const userId = userProfile?.user?.id;

  const tripsEndpoint =  `issuance/policies/user-specific/trips?staff_id=${userId}`
  const travellersEndpoint = `issuance/policies/user-specific/travellers?staff_id=${userId}`

  const handleTripDetails = (row) => {
    return `${row.id}`;
  };

//   const handleTravellerDetails = (row) => {
//     return `${row.id}`; 
//   };
  

  const tripsConfig = {
    fields: [
      { key: "id", label: "Booking Id" },
      { key: "cover_type", label: "Cover Type" },
      { key: "traveller_from_name", label: "From" },
      { key: "traveller_to_name", label: "To" },
      { key: "no_of_pax", label: "Pax" },
      { key: "coverage_start_date", label: "Start Date" },
      { key: "coverage_end_date", label: "End Date" },
      { key: "created_on", label: "Date", type: "datetime" },
    ],
    actions: [
      {
        label: "Details",
        to: (row) => handleTripDetails(row),
        isButton: true,
      },
    ],
  };

  const travellersConfig = {
    fields: [
      { key: "id", label: "Booking Id" },
      { key: "first_name", label: "Name" },
      { key: "cover_number", label: "Cover Number" },
      { key: "cover_type", label: "Cover Type" },
      { key: "nationality_name", label: "Nationality" },
      { key: "email", label: "Email" },
      { key: "dob", label: "DOB" },
      { key: "created_on", label: "Date", type: "datetime" },
    ],
//     actions: [
//     {
//       label: "Details",
//       to: (row) => handleTravellerDetails(row),
//       isButton: true,
//     },
//   ],
  };

  return (
    <>
      <Tabs defaultValue="trips" variant="pills">
        <Tabs.List>
          <Tabs.Tab value="trips">Trips</Tabs.Tab>
          <Tabs.Tab value="travellers">Travellers</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="trips" mt={"md"}>
          <DataWrapper endpoint={tripsEndpoint} config={tripsConfig} />
        </Tabs.Panel>

        <Tabs.Panel value="travellers" mt={"md"}>
          <DataWrapper
            endpoint={travellersEndpoint}
            config={travellersConfig}
          />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};

export default PolicyIssuedByUser;